import { EventEmitter, Component, forwardRef, Output, ViewChild, NgModule } from '@angular/core';
import { FormControl, NG_VALUE_ACCESSOR, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/forms';

const _c0 = ["searchInputElement"];
class MtSearchBarComponent {
    constructor() {
        // *** END -- CONTROL VALUE ACCESSOR ***
        this.searchControlCreated = new EventEmitter();
        this.onSearch = new EventEmitter();
        this.onReady = new EventEmitter();
        this.searchControl = new FormControl();
        this.subscriptions = new Subscription();
    }
    // *** CONTROL VALUE ACCESSOR ***
    /* tslint:disable:member-ordering */
    writeValue(obj) {
        this.searchControl.setValue(obj);
        this.searchControl.updateValueAndValidity();
    }
    registerOnChange(fn) {
        this.onValueChanged = fn;
    }
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    setDisabledState(isDisabled) {
        if (isDisabled) {
            this.searchControl.disable();
        }
        else {
            this.searchControl.enable();
        }
    }
    ngOnInit() {
        this.subscriptions.add(this.searchControl.valueChanges.pipe(debounceTime(300)).subscribe((value) => {
            this.onSearch.emit(value);
        }));
        this.subscriptions.add(this.searchControl.valueChanges.subscribe((value) => {
            var _a;
            (_a = this.onValueChanged) === null || _a === void 0 ? void 0 : _a.call(this, value);
        }));
        this.searchControlCreated.emit(this.searchControl);
    }
    ngAfterViewInit() {
        this.onReady.emit({
            clearSearch: this.clearSearch.bind(this),
            getSearchControl: (() => this.searchControl).bind(this),
            getSearchInputElement: (() => this.searchInputElement).bind(this),
        });
    }
    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }
    touched() {
        var _a;
        (_a = this.onTouched) === null || _a === void 0 ? void 0 : _a.call(this);
    }
    clearSearch() {
        var _a;
        this.searchControl.setValue('');
        (_a = this.onTouched) === null || _a === void 0 ? void 0 : _a.call(this);
    }
}
MtSearchBarComponent.ɵfac = function MtSearchBarComponent_Factory(t) { return new (t || MtSearchBarComponent)(); };
MtSearchBarComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: MtSearchBarComponent, selectors: [["mt-search-bar"]], viewQuery: function MtSearchBarComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c0, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.searchInputElement = _t.first);
    } }, outputs: { searchControlCreated: "searchControlCreated", onSearch: "onSearch", onReady: "ready" }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                multi: true,
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => MtSearchBarComponent)
            },
        ])], decls: 22, vars: 1, consts: [[1, "input-group"], ["type", "text", "placeholder", "Search", 1, "form-control", 3, "formControl", "focus"], ["searchInputElement", ""], [1, "input-group-btn"], ["type", "button", 1, "btn", "btn-default", "btn-nohover", "btn-flat", 3, "click"], [1, "fa"], ["aria-hidden", "true", 1, "fa", "fa-remove"]], template: function MtSearchBarComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtext(0, "\n        ");
        ɵngcc0.ɵɵelementStart(1, "div");
        ɵngcc0.ɵɵtext(2, "\n            ");
        ɵngcc0.ɵɵelementStart(3, "div", 0);
        ɵngcc0.ɵɵtext(4, "\n                ");
        ɵngcc0.ɵɵelementStart(5, "input", 1, 2);
        ɵngcc0.ɵɵlistener("focus", function MtSearchBarComponent_Template_input_focus_5_listener() { return ctx.touched(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(7, "\n                ");
        ɵngcc0.ɵɵelementStart(8, "span", 3);
        ɵngcc0.ɵɵtext(9, "\n                    ");
        ɵngcc0.ɵɵelementStart(10, "button", 4);
        ɵngcc0.ɵɵlistener("click", function MtSearchBarComponent_Template_button_click_10_listener() { return ctx.clearSearch(); });
        ɵngcc0.ɵɵtext(11, "\n                        ");
        ɵngcc0.ɵɵelement(12, "i", 5);
        ɵngcc0.ɵɵtext(13, "\n                        ");
        ɵngcc0.ɵɵelement(14, "i", 6);
        ɵngcc0.ɵɵtext(15, "\n                        ");
        ɵngcc0.ɵɵelement(16, "i", 5);
        ɵngcc0.ɵɵtext(17, "\n                    ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(18, "\n                ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(19, "\n            ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(20, "\n        ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(21, "\n    ");
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("formControl", ctx.searchControl);
    } }, directives: [ɵngcc1.DefaultValueAccessor, ɵngcc1.NgControlStatus, ɵngcc1.FormControlDirective], encapsulation: 2 });
MtSearchBarComponent.propDecorators = {
    searchControlCreated: [{ type: Output, args: ['searchControlCreated',] }],
    onSearch: [{ type: Output, args: ['onSearch',] }],
    onReady: [{ type: Output, args: ['ready',] }],
    searchInputElement: [{ type: ViewChild, args: ['searchInputElement', { static: false },] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MtSearchBarComponent, [{
        type: Component,
        args: [{
                providers: [
                    {
                        multi: true,
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => MtSearchBarComponent)
                    },
                ],
                selector: 'mt-search-bar',
                template: `
        <div>
            <div class="input-group">
                <input type="text" #searchInputElement [formControl]="searchControl" class="form-control" placeholder="Search" (focus)="touched()" />
                <span class="input-group-btn">
                    <button type="button" (click)="clearSearch()" class="btn btn-default btn-nohover btn-flat">
                        <i class="fa"></i>
                        <i class="fa fa-remove" aria-hidden="true"></i>
                        <i class="fa"></i>
                    </button>
                </span>
            </div>
        </div>
    `
            }]
    }], function () { return []; }, { searchControlCreated: [{
            type: Output,
            args: ['searchControlCreated']
        }], onSearch: [{
            type: Output,
            args: ['onSearch']
        }], onReady: [{
            type: Output,
            args: ['ready']
        }], searchInputElement: [{
            type: ViewChild,
            args: ['searchInputElement', { static: false }]
        }] }); })();

class MtSearchBarControlModule {
}
MtSearchBarControlModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: MtSearchBarControlModule });
MtSearchBarControlModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function MtSearchBarControlModule_Factory(t) { return new (t || MtSearchBarControlModule)(); }, imports: [[FormsModule, ReactiveFormsModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(MtSearchBarControlModule, { declarations: function () { return [MtSearchBarComponent]; }, imports: function () { return [FormsModule, ReactiveFormsModule]; }, exports: function () { return [MtSearchBarComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MtSearchBarControlModule, [{
        type: NgModule,
        args: [{
                declarations: [MtSearchBarComponent],
                exports: [MtSearchBarComponent],
                imports: [FormsModule, ReactiveFormsModule]
            }]
    }], null, null); })();

/**
 * Generated bundle index. Do not edit.
 */

export { MtSearchBarComponent, MtSearchBarControlModule };

//# sourceMappingURL=mt-ng2-searchbar-control.js.map